import { permitir_informar_data_de_referencia_do_censo } from "./permitir-informar-data-de-referencia-do-censo/index";

const data_de_referencia_do_censo = [
  ...permitir_informar_data_de_referencia_do_censo,
];

export { data_de_referencia_do_censo };
